import { InputMultiSelectControl } from './components/control'
import { InputMultiSelectDropdownList } from './components/dropdown-list'
import { InputMultiSelectHelperText } from './components/helper-text'
import { InputMultiSelectLabel } from './components/label'
import { InputMultiSelectRoot } from './components/root'

export const InputMultiSelect = {
  Root: InputMultiSelectRoot,
  Label: InputMultiSelectLabel,
  HelperText: InputMultiSelectHelperText,
  Control: InputMultiSelectControl,
  DropdownList: InputMultiSelectDropdownList,
}
